<template>
  <div class="container">
    <div class="navi">
      <span class="icon-arrow-left" @click="goto('/clean-step2')"></span>
    </div>
    <div class="title">是否有下列清洁区域</div>
    <div class="main">
      <div class="item">
        <img src="../../assets/img/clean/extra/garage.svg">
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='order.data.garage' type='garage'>
            <span slot="label">车库</span>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <img src="../../assets/img/clean/extra/storage.svg">
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='order.data.storage' type='storage'>
            <span slot="label">仓库</span>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <img src="../../assets/img/clean/extra/swimming_pool.svg">
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='order.data.swimming_pool' type='swimming_pool'>
            <span slot="label">泳池</span></span>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <img src="../../assets/img/clean/extra/forecourt.svg">
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='order.data.forecourt' type='forecourt'>
            <span slot="label">前院</span>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <img src="../../assets/img/clean/extra/backyard.svg">
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='order.data.backyard' type='backyard'>
            <span slot="label">后院</span>
          </v-counter>
        </div>
      </div>


    </div>
    <div class="btn-box-fix">
      <div class="btn-container">

		      <div class="btn active" @click="orderUpdateAll('/clean-step4')" >{{btnText()}}</div>
      </div>
    </div>
    <img :src="pixelURL('clean','teshuquyu')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'clean-step3',
  data () {
    return {
      order:{}
    }
  },
  methods: {
    plus: function (type) {
      eval('this.order.data.'+type+'=this.order.data.'+type+'+1');
			if(this.order.data[type]>20){
				this.order.data[type]=20;
			}
		},
    minus: function (type) {
			eval('this.order.data.'+type+'=this.order.data.'+type+'-1');
			if(this.order.data[type]<0){
				this.order.data[type]=0;
			}
    },
    btnText(){
      if(this.isSkipable()){
          return "下一步";
      }
      else{
          return "跳过"
      }
    },
    isSkipable(){
      let theData = this.order.data;
      let sum = theData.swimming_pool+theData.storage+theData.garage+theData.forecourt+theData.backyard>0;
      if(sum){
        return true;
      }
    },
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "clean"){
        this.order = localParsed;
        if(this.order.data.house_type!=3&&this.order.data.house_type!=4&&this.order.data.house_type!=6){
          this.goto('/clean-step4')
        }
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.item{
  display: flex;
	justify-content:center;
  align-items:center;
  margin-bottom:6px;
  img{
    width:60px;
  }
  .counter{
    padding-top:8px;
    margin-left:14px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/clean/step3.vue